import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
// react-leaflet v4 renamed <Map> to <MapContainer>; every other component
// (TileLayer, Marker, Popup) keeps the same name and props.
import { MapContainer, TileLayer } from "react-leaflet";
import auth from "../../../core/auth";
import DynamicMarker from "./marker";
import Mqtt_statusBar from "../../../mqtt/mqtt_statusbar";
const appparameters = require("../../../core/common.jsx");

const Map_view = (props) => {
  const lebanonLO = 33.893791;
  const lebanonLA = 35.501777;
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(auth.getUserData()),
  };
  const [loading, setLoading] = useStateIfMounted(true);
  const [state, setState] = useStateIfMounted({
    sites: [],
    sites_lastseen: [],
  });

  useEffect(() => {
    fetch(
      appparameters.backend_app_url + "/frontend/getacountcontacts",
      requestOptions,
    )
      .then((response) => response.json())
      .then((responseData) => {
        //console.log("response data");
        //console.log(responseData);
        setState({
          ...state,
          sites: responseData,
        });
        setLoading(false);
      })
      .catch((error) => console.warn(error));
  }, []);

  //when componenet unmount
  useEffect(() => () => {}, []);

  if (loading) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading map view ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else if (state.sites.length > 0) {
    return (
      <div className="container">
        <Mqtt_statusBar />
        <MapContainer
          center={[lebanonLO, lebanonLA]}
          zoom={8}
          scrollWheelZoom={true}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.sascontrollers.com/">S.& A.S.Co.Ltd</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {state.sites.map((site) => (
            <DynamicMarker
              key={site.sitedetails[0]["_id"]}
              index={site.sitedetails[0]["_id"]}
              siteId={site.sitedetails[0]["Surf ID"]}
              siteInformation={site["location_name"]}
              siteDescription={site["description"]}
              hardwareversion={site.sitedetails[0]["Hardware Version"]}
              softwareversion={site.sitedetails[0]["Software Version"]}
              revisionnumber={site.sitedetails[0]["Revision Number"]}
              serialnumber={site.sitedetails[0]["Serial Number"]}
              type={site.sitedetails[0]["Type"]}
              SDPresence={site.sitedetails[0]["SD Presence"]}
              mac={site.sitedetails[0]["Mac"]}
              latitude={site["latitude"]}
              longitude={site["longitude"]}
              mail={site["mail"]}
              subtype={site.sitedetails[0]["SubType"]}
              userpass={site.sitedetails[0]["Surf Password"]}
              clientpass={site.sitedetails[0]["Client Password"]}
              seniorpass={site.sitedetails[0]["Senior Password"]}
              saspass={site.sitedetails[0]["SAS Password"]}
              designtype={site.sitedetails[0]["Design Type"]}
              timezone={site.sitedetails[0]["TimeZone"]}
              fu={site.sitedetails[0]["Firmware Upgrade"]}
              lr={site.sitedetails[0]["Log Retrieve"]}
              fl={site.sitedetails[0]["Faults Log"]}
              fr={site.sitedetails[0]["Fault Reset"]}
              entered_pass={site["entered_pass"]}
              lastseen="N/A"
              status="N/A"
              parentPropsHistory={props.history}
            />
          ))}
        </MapContainer>
        <br></br>
        <div className="alert alert-info" role="alert">
          <center>
            Devices with no geolocation parameters will not be visible.
          </center>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container">
        <div>
          <img src={require("./../../../images/sadface.svg")} />
          <h6 />
          <h6>Empty account</h6>
          <h7>Click add site above to add a new device</h7>
        </div>
      </div>
    );
  }
};
export default Map_view;
